module.exports = __webpack_public_path__ + "static/img/026.1251361.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fushen/026.png
// module id = wmET
// module chunks = 0